<template>
    <div>
        <!-- SSO Options -->
        <div class="row sso justify-content-center mt-3">
            <div class="col-12">
                <a :href="getSsoUrl('google')" class="btn btn-sso btn-block btn-slimpad btn-google">
                    <span>
                        <img src="/img/google-logo.png" alt="Google" width="18" height="18" style="margin-top: -2px;">
                    </span>
                    <span class="text">Login with Google</span>
                </a>
            </div>
            <div class="col-12">
                <a :href="getSsoUrl('facebook')" class="btn btn-sso btn-block btn-slimpad btn-facebook mt-1">
                    <span>
                        <font-awesome-icon :icon="['fab', 'facebook']" />
                    </span>
                    <span class="text">Login with Facebook</span>
                </a>
            </div>
            <div class="col-12">
                <a :href="getSsoUrl('spotify')" class="btn btn-sso btn-block btn-slimpad btn-spotify mt-1">
                    <span>
                        <font-awesome-icon :icon="['fab', 'spotify']" />
                    </span>
                    <span class="text">Login with Spotify</span>
                </a>
            </div>
        </div>

        <!-- 'Or' Separator -->
        <div class="text-center my-3 text-white">
            <span>or</span>
        </div>

        <!-- Existing Register Button -->
        <div class="text-center">
            <a :href="registerUrl" class="btn btn-link text-white btn-sm">Use your email</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            registerUrl: {
                type: String,
                required: false,
                default: '/register?return=/subscribe'
            },
            returnUrl: {
                type: String,
                required: false,
                default: ''
            },
        },

        data() {
            return {
            }
        },

        mounted() {

        },

        methods: {
            // Generate SSO URLs with via and return parameters
            getSsoUrl(provider) {
                let url = `/register/${provider}`;
                if (this.returnUrl && this.returnUrl.length > 0) {
                    url += `?via=/subscribe&return=${encodeURIComponent(this.returnUrl)}`;
                } else {
                    url += `?return=/subscribe`;
                }
                return url;
            },
        }
    }
</script>
